__turbopack_context__.v({
  "className": "linottefont_e9a84dba-module__lZAJYG__className",
  "variable": "linottefont_e9a84dba-module__lZAJYG__variable",
});
